// Consent Matrix
export const FETCH_CONSENT_MATRIX = 'FETCH_CONSENT_MATRIX'
export const FETCH_CONSENT_MATRIX_LOADING = 'FETCH_CONSENT_MATRIX_LOADING'
export const FETCH_CONSENT_MATRIX_ERROR = 'FETCH_CONSENT_MATRIX_ERROR'
export const FETCH_CONSENT_MATRIX_SUCCESS = 'FETCH_CONSENT_MATRIX_SUCCESS'

// Consent & TOC copies
export const FETCH_CONSENT_STATUS = 'FETCH_CONSENT_STATUS'
export const FETCH_CONSENT_STATUS_LOADING = 'FETCH_CONSENT_STATUS_LOADING'
export const FETCH_CONSENT_STATUS_ERROR = 'FETCH_CONSENT_STATUS_ERROR'
export const FETCH_CONSENT_STATUS_SUCCESS = 'FETCH_CONSENT_STATUS_SUCCESS'

// Consent & TOC copies
export const UPDATE_CONSENTS = 'UPDATE_CONSENTS'
export const UPDATE_CONSENTS_LOADING = 'UPDATE_CONSENTS_LOADING'
export const UPDATE_CONSENTS_ERROR = 'UPDATE_CONSENTS_ERROR'
export const UPDATE_CONSENTS_SUCCESS = 'UPDATE_CONSENTS_SUCCESS'

export const INITIATE_COUNTRY_CONFIRMATION = 'INITIATE_COUNTRY_CONFIRMATION'
export const CANCEL_COUNTRY_CONFIRMATION = 'CANCEL_COUNTRY_CONFIRMATION'

export const STAGE_UNCONSENTED_LIST = 'STAGE_UNCONSENTED_LIST'
export const STAGE_CONSENT_SCREEN_NAME = 'STAGE_CONSENT_SCREEN_NAME'
